export default __webpack_public_path__ + "static/media/radiance.2bcb7843.png";